import Request from "../../api/Request";
import SubscriptionCreateParcel from "../endpoints/subscription/SubscriptionCreateParcel";
import Toasts, {TOAST_SUCCESS, TOAST_WARN} from "../../scomponents/toasts/Toasts";
import __ from "../../i18n";
import validateEmailAddress from "../validators/validateEmailAddress";


export default function SubscriptionHandler(form) {

    const getEmailInput = () => {
        return form.elements['email'];
    }

    const getEmail = () => {
        return getEmailInput().value;
    };

    const reset = () => {
        form.reset();
        document.activeElement.blur();
    }

    const subscribe = () => {

        Request.add(new SubscriptionCreateParcel(getEmail()))
            .then(() => {
                Toasts.add(TOAST_SUCCESS, __('Your email has been saved successfully!'));
                reset();
            })
            .catch(error => {
                Toasts.add(TOAST_WARN, error.getMessage());
            });

    };


    const validate = () => {
        const email = getEmail();

        if (email.trim() === '') {
            return __('Please enter your email');
        }

        if (!validateEmailAddress(email)) {
            return __('Invalid email');
        }

        return null;
    };

    form.addEventListener('submit', function (ev) {
        ev.preventDefault();

        const error = validate();
        if (error !== null) {
            Toasts.add(TOAST_WARN, error);
            return;
        }

        subscribe();
    });

}
